import actions from "./actions";

const initialState = {
  error: null,
  loading: false,
  crawler: {},
  crawlerPlanResult: {},
};

export default function crawlPlanSaleReducer(state = initialState, action) {
  switch (action.type) {
    case actions.CRAWL_PLAN_SALE_REQUEST:
      return {
        ...state,
        loading: true,
        crawler: {},
      };
    case actions.CRAWL_PLAN_SALE_SUCCESS:
      return {
        ...state,
        loading: false,
        crawler: action.crawler,
      };
    case actions.CRAWL_PLAN_SALE_ERROR:
      return {
        ...state,
        loading: false,
        crawler: {},
      };
    case actions.GET_CRAWL_PLAN_SALE_REQUEST:
      return {
        ...state,
        crawler: {},
      };
    case actions.GET_CRAWL_PLAN_SALE_SUCCESS:
      return {
        ...state,
        crawler: action.crawler,
      };
    case actions.GET_CRAWL_PLAN_SALE_ERROR:
      return {
        ...state,
        crawler: {},
        error: action.error,
      };
    case actions.DOWNLOAD_CRAWL_PLAN_SALE_REQUEST:
      return {
        ...state,
      };
    case actions.DOWNLOAD_CRAWL_PLAN_SALE_SUCCESS:
      return {
        ...state,
        crawler: action.crawler,
      };
    case actions.DOWNLOAD_CRAWL_PLAN_SALE_ERROR:
      return {
        ...state,
        error: action.error,
      };
    case actions.CRAWL_PLAN_RESULT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case actions.CRAWL_PLAN_RESULT_SUCCESS:
      return {
        ...state,
        loading: false,
        crawlerPlanResult: action.crawlerPlanResult
      };
    case actions.CRAWL_PLAN_RESULT_ERROR:
      return {
        ...state,
        loading: false,
      };
    case actions.GET_CRAWL_PLAN_RESULT_REQUEST:
      return {
        ...state,
        crawlerPlanResult: {},
      };
    case actions.GET_CRAWL_PLAN_RESULT_SUCCESS:
      return {
        ...state,
        crawlerPlanResult: action.crawlerPlanResult,
      };
    case actions.GET_CRAWL_PLAN_RESULT_ERROR:
      return {
        ...state,
        crawlerPlanResult: {},
        error: action.error,
      };
    default:
      return state;
  }
}
